import { Component } from '@angular/core';
import { PagesService } from '@app/_services/pages.service';
import { Subscription } from 'rxjs';
import { AuthenticationService, FormsService, ListsService, ObjectsService } from '@app/_services';
import {SwiperOptions} from 'swiper';

@Component({
  selector: 'jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.scss']
})
export class JumbotronComponent {
  private subscription:Subscription
  public currentPage:any;
  public pagePictures=[];
  public showJumbotronEditor:boolean;
  public contentCenter = true;

  public swiperConfig: SwiperOptions = {
    // loop: true,
    effect:"fade",
    slidesPerView: 1,
    spaceBetween: 0,
    autoplay: {
       delay: 5000,
    },
    speed:2000,
  };

  constructor(
    private pagesService: PagesService,
    public authService: AuthenticationService,
    private formsService: FormsService,
    private objectsService: ObjectsService,
    private listsService: ListsService
  ){}

  ngOnInit(){
    this.subscription = this.pagesService.currentPageSubject.subscribe(
      resp=> {
        this.currentPage = resp;
        if (this.currentPage) {
          if(this.slides?.length){
            this.pagePictures = this.slides.map(slide=>({
              header:  this.slideHeader(slide),
              subheader: this.slideSubheader(slide),
              text: this.slideText(slide),
              link: this.slideLink(slide),
              img: this.slideImg1200(slide)
          }));
          this.contentCenter = false;
        }else{
          if(this.currentPage.images?.data?.length){
            let pictures = this.currentPage.images.data;
            this.pagePictures = pictures.map(picture=>picture.links.full+'?with=1200')
          }else{
            let parents = this.currentPage.parents.data
            let content = parents.map(page=>page.images.data).filter(data=>data.length)
            this.pagePictures = content.pop()?.map(picture=>picture.links.full+'?with=1200')
          }
        }          
        }else{this.pagePictures = [];}
      }
    )
  }
  ngOnDestoy(){
    this.subscription.unsubscribe();
  }

  get name(){
    let name:string
    if(this.currentPage){
      name = this.currentPage?.h1 || this.currentPage?.name;
      let parents = this.currentPage?.parents?.data
      if(parents){
        if (parents[1]?.type.name=='nav-page'){
          if (parents[2]) name = parents[2].h1|| parents[2].name
        }else{
          if (parents[1]) name = parents[1].h1|| parents[1].name
        }
      }
    }
    return name
  }

  get bgStyle(){
    let height = 150;
    let pictURL:string;
    if (this.pagePictures){
      height = 150;
      pictURL = this.pagePictures[0];
    }

    return {
      'height': (this.mainPage?700:pictURL?400:height) + 'px'
    }
  }

  get h1Style(){
    return {
      color: this.pagePictures?'var(--white)':'var(--second-act)',
      'align-self': this.mainPage?'center':'flex-start',
      'text-align': this.mainPage?'center':'left',
      'width': this.mainPage?'900px':null,
      'border-bottom':this.mainPage?null:'12px solid #2EB2E8'
    }
  }

  get mainPage(){
    return this.currentPage?.parents?.data.length === 0;
  }

  get editable(){
    return this.currentPage&&(this.authService.privileges?.admin|| this.authService.privileges?.editor);
  }

  get editMode(){
    return this.pagesService.editMode;
  }

  toggleEditMode(){
    this.pagesService.editMode = !this.pagesService.editMode;
  }

  get isRootPage(){
    return !this.pagesService.currentPage?.parents.data.length && this.pagesService.currentPage
  }

  get since(){
    return this.currentPage?.link === '/'
  }

  get slides(){
    return this.currentPage.slides.data
  }

  slideHeader(slide){
    return this.objectsService.getValue(slide,'header')
  }

  slideSubheader(slide){
    return this.objectsService.getValue(slide,'subheader')
  }
  slideText(slide){
    return this.objectsService.getValue(slide,'text')
  }
  slideLink(slide){
    return this.objectsService.getValue(slide,'link')
  }
  slideImg(slide){
    return this.objectsService.getValue(slide,'image')?.links.thumb
  }
  slideImg1200(slide){
    return this.objectsService.getValue(slide,'image')?.links.full+'?with=1200'
  }

  slideAdd(){
    let attach = {model_type: 'page', model_id: this.pagesService.currentPage.id, group: 'slides', ord: 0};
    this.formsService.createObject('cards-section-slides', {extraProps: {attach: attach}})
  }

  slideOrd(slide){
    return slide.pivot?.ord
  }

  slideEdit(slide) {
    this.formsService.editObject(slide.id);
  }

  slideMove(slide, ord) {
    this.objectsService.move(slide.id, {modelType: 'page', modelId: this.pagesService.currentPage.id, ord: ord}).subscribe(res => {
      this.listsService.refresh();
    });
  }

  slideDestroy(slide) {
    this.objectsService.destroy(slide.id).subscribe(res => {
      this.listsService.refresh();
    });
  }

}
